import {createContext} from "react";

import {ThirdPartyComponent, ThirdPartyService, ThirdPartySubComponent} from "@/lib/queries/checks.ts";

export interface ThirdPartyComponentSelectContextValue {
  group: ThirdPartyService;
  expandedId: string | null;
  onToggleExpand: (id: string) => void;
  onSubComponentSelect: (component: ThirdPartyComponent, subComponent: ThirdPartySubComponent) => void;
}

export const ThirdPartyComponentSelectContext = createContext<ThirdPartyComponentSelectContextValue | null>(null);
